<template>
  <iframe
    src="/swagger-ui/index.html"
    style="width: 100%; height: 100%; border: none"
  ></iframe>
</template>

<script>
export default {
  name: "Docs",
};
</script>

<style scoped></style>
